export default {
  title: 'Administrați afacerea de oriunde',
  description: 'Conectați-vă la contul dvs.',
  form: {
    email: {
      label: 'E-mail',
      placeholder: 'Introduceți e-mailul',
    },
    password: {
      label: 'Parolă',
      placeholder: 'Introduceți parola',
    },
    error_messages: {
      missing_info: 'Informații lipsă',
      wrong_credentials: 'E-mail sau parolă incorectă',
    },
  },
  buttons: {
    login: 'Conectare',
    forgot_password: 'Parolă uitată',
  },
  white_label: {
    title: 'Conectați-vă la tabloul de bord',
    form: {
      email: {
        label: 'Adresă de e-mail',
        placeholder: 'tu@restaurant.com',
      },
      password: {
        label: 'Parolă',
        placeholder: 'Introduceți parola',
      },
    },
    buttons: {
      login: 'Conectare',
    },
    intro: {
      eyebrow: 'Gestionare comenzi',
      headline: 'Administrați restaurantul de oriunde.',
      description: 'Comenzi, meniuri, program și plăți — totul într-un singur loc.',
      features: {
        live: {
          title: 'Live',
          subtitle: 'urmărire comenzi',
        },
        instant: {
          title: 'Instant',
          subtitle: 'modificări meniu',
        },
        any_device: {
          title: 'Orice dispozitiv',
          subtitle: 'telefon sau tabletă',
        },
      },
    },
  },
};
